import React from 'react';

function AboutSelectiveTests() {
  return (
    <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
      <div className="card" style={{ textAlign: 'center', padding: '60px 24px', marginBottom: '30px' }}>
        <h1 style={{ fontSize: '48px', marginBottom: '20px', color: '#4f46e5' }}>
          What is the Selective High School Test?
        </h1>
        <p style={{ fontSize: '20px', color: '#666', maxWidth: '800px', margin: '0 auto' }}>
          Everything you need to know about NSW Selective High School entrance exams
        </p>
      </div>

      <div className="card" style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '32px', marginBottom: '20px', color: '#4f46e5' }}>Overview</h2>
        <p style={{ fontSize: '18px', lineHeight: '1.8', color: '#666', marginBottom: '20px' }}>
          The Selective High School Placement Test is an examination for Year 6 students in New South Wales 
          who wish to gain entry into one of the state's selective high schools for Year 7. These schools 
          cater to academically gifted students and provide a challenging, enriched curriculum.
        </p>
      </div>

      <div className="card" style={{ marginBottom: '30px', background: '#f0f9ff' }}>
        <h2 style={{ fontSize: '28px', marginBottom: '20px', color: '#4f46e5' }}>Test Components</h2>
        <div style={{ display: 'grid', gap: '20px' }}>
          <div style={{ padding: '20px', background: 'white', borderRadius: '8px', borderLeft: '4px solid #4f46e5' }}>
            <h3 style={{ fontSize: '22px', marginBottom: '10px', color: '#4f46e5' }}>📖 Reading</h3>
            <p style={{ color: '#666', lineHeight: '1.6' }}>
              Tests comprehension, vocabulary, and ability to analyze various text types including 
              fiction, non-fiction, and poetry.
            </p>
          </div>
          <div style={{ padding: '20px', background: 'white', borderRadius: '8px', borderLeft: '4px solid #10b981' }}>
            <h3 style={{ fontSize: '22px', marginBottom: '10px', color: '#10b981' }}>🔢 Mathematics</h3>
            <p style={{ color: '#666', lineHeight: '1.6' }}>
              Assesses numerical reasoning, problem-solving skills, and understanding of mathematical 
              concepts appropriate for Year 6 level.
            </p>
          </div>
          <div style={{ padding: '20px', background: 'white', borderRadius: '8px', borderLeft: '4px solid #f59e0b' }}>
            <h3 style={{ fontSize: '22px', marginBottom: '10px', color: '#f59e0b' }}>🧠 Thinking Skills</h3>
            <p style={{ color: '#666', lineHeight: '1.6' }}>
              Evaluates logical reasoning, critical thinking, and ability to solve complex problems 
              using various strategies.
            </p>
          </div>
          <div style={{ padding: '20px', background: 'white', borderRadius: '8px', borderLeft: '4px solid #ef4444' }}>
            <h3 style={{ fontSize: '22px', marginBottom: '10px', color: '#ef4444' }}>✍️ Writing</h3>
            <p style={{ color: '#666', lineHeight: '1.6' }}>
              Tests creative and persuasive writing abilities, including structure, vocabulary, 
              grammar, and expression of ideas.
            </p>
          </div>
        </div>
      </div>

      <div className="card" style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '28px', marginBottom: '20px', color: '#4f46e5' }}>Important Information</h2>
        <ul style={{ fontSize: '18px', lineHeight: '2', color: '#666', paddingLeft: '20px' }}>
          <li>The test is typically held in May each year</li>
          <li>Students must be in Year 6 to sit for the test</li>
          <li>Results are used for Year 7 placement in the following year</li>
          <li>Multiple selective high schools are available across NSW</li>
          <li>Practice and preparation can significantly improve performance</li>
        </ul>
      </div>

      <div className="card" style={{ marginBottom: '30px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
        <h2 style={{ fontSize: '28px', marginBottom: '20px' }}>Official NSW Education Resources</h2>
        <p style={{ fontSize: '16px', marginBottom: '20px', opacity: '0.9' }}>
          For official information and resources, visit these NSW Department of Education pages:
        </p>
        <div style={{ display: 'grid', gap: '15px' }}>
          <a 
            href="https://education.nsw.gov.au/public-schools/selective-high-schools-and-opportunity-classes/year-7"
            target="_blank"
            rel="noopener noreferrer"
            style={{ 
              display: 'block',
              padding: '15px 20px', 
              background: 'rgba(255,255,255,0.2)', 
              borderRadius: '8px',
              color: 'white',
              textDecoration: 'none',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.3)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
          >
            <strong>Selective High Schools - Year 7</strong>
            <br />
            <span style={{ fontSize: '14px', opacity: '0.9' }}>Official information about selective high schools</span>
          </a>
          <a 
            href="https://education.nsw.gov.au/public-schools/selective-high-schools-and-opportunity-classes/year-7/the-test"
            target="_blank"
            rel="noopener noreferrer"
            style={{ 
              display: 'block',
              padding: '15px 20px', 
              background: 'rgba(255,255,255,0.2)', 
              borderRadius: '8px',
              color: 'white',
              textDecoration: 'none',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.3)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
          >
            <strong>About The Test</strong>
            <br />
            <span style={{ fontSize: '14px', opacity: '0.9' }}>Details about test format and content</span>
          </a>
          <a 
            href="https://education.nsw.gov.au/schooling/parents-and-carers/choosing-a-school-setting/selective-high-schools/placement-test/selective-high-school-practice-tests.html"
            target="_blank"
            rel="noopener noreferrer"
            style={{ 
              display: 'block',
              padding: '15px 20px', 
              background: 'rgba(255,255,255,0.2)', 
              borderRadius: '8px',
              color: 'white',
              textDecoration: 'none',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.3)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
          >
            <strong>Preparing for the Test</strong>
            <br />
            <span style={{ fontSize: '14px', opacity: '0.9' }}>Official preparation resources and practice tests</span>
          </a>
          <a 
            href="https://education.nsw.gov.au/schooling/parents-and-carers/choosing-a-school-setting/selective-high-schools"
            target="_blank"
            rel="noopener noreferrer"
            style={{ 
              display: 'block',
              padding: '15px 20px', 
              background: 'rgba(255,255,255,0.2)', 
              borderRadius: '8px',
              color: 'white',
              textDecoration: 'none',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.3)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
          >
            <strong>Frequently Asked Questions</strong>
            <br />
            <span style={{ fontSize: '14px', opacity: '0.9' }}>Common questions about selective high schools</span>
          </a>
        </div>
      </div>

      <div className="card" style={{ textAlign: 'center', padding: '40px 24px' }}>
        <h2 style={{ fontSize: '28px', marginBottom: '20px', color: '#4f46e5' }}>Ready to Start Practicing?</h2>
        <p style={{ fontSize: '16px', color: '#666', marginBottom: '30px' }}>
          Use our free practice tests to prepare for the selective high school entrance exam
        </p>
        <a href="/exams" style={{ textDecoration: 'none' }}>
          <button className="btn-primary" style={{ fontSize: '18px', padding: '16px 32px' }}>
            Start Practice Tests
          </button>
        </a>
      </div>
    </div>
  );
}

export default AboutSelectiveTests;
